import { Expose } from 'class-transformer';
import { User } from '../user/user';
import { Employee } from './employee';
import { HrLookup } from '../hr-lookup/hr-lookup';
//import { SalaryType } from '@shared/enums/salary-type';
export class Salary {
  @Expose() id: string | undefined;
  @Expose() employeeId: string | undefined;
  @Expose() userId: string | undefined;
  @Expose() startDate: Date | undefined;
  @Expose() endDate: Date | undefined;
  @Expose() businessId: string | undefined;
  @Expose() salarySetup: string | undefined;
  @Expose() CreatedOn: Date | undefined;
  @Expose() updatedOn: Date | undefined;
  @Expose() createById: string | undefined;
  @Expose() createdBy: User;
  @Expose() employee: Employee | undefined;
  @Expose() allowances: HrLookup[] | undefined;
  @Expose() bonuses: HrLookup[] | undefined;
  //salaryType: SalaryType
}
export class CreateSalary {
  @Expose() employeeId: string | undefined;
  @Expose() startDate: Date | undefined;
  @Expose() endDate: Date | undefined;
  @Expose() businessId: string | undefined;
  @Expose() salarySetup: string | undefined;
  @Expose() employee: Employee | undefined;
  @Expose() allowanceIds: string[] | undefined;
  @Expose() bonusIds: string[] | undefined;
}

export class UpdateSalary {
  @Expose() id: string | undefined;
  @Expose() startDate: Date | undefined;
  @Expose() endDate: Date | undefined;
  @Expose() businessId: string | undefined;
  @Expose() salarySetup: string | undefined;
  @Expose() employee: Employee | undefined;
  @Expose() allowanceIds: string[] | undefined;
  @Expose() bonusIds: string[] | undefined;
}

// export interface SalarySetupHourly {
//   SalaryType: string;
//   ISOCurrencyCode: string;
//   Setup: {
//     InternalRate: {
//       RegularRate: number;
//       OvertimeRate: number;
//     };
//     EmployeeRate: {
//       RegularRate: number;
//       OvertimeRate: number;
//     };
//   };
// }
export interface OvertimeSetup {
  OvertimeStatus: string;
  Rate: number;
}

export interface InternalRate {
  RegularRate: number;
  OvertimeRate: number;
}

export interface EmployeeRate {
  RegularRate: number;
  OvertimeRate: number;
}

export interface GrossSalaryPackage {
  HouseRent: number;
  GroceryAllowence: number;
}

export interface SalarySetup {
  SalaryType: string;
  ISOCurrencyCode: string;
  Setup: 
    | { InternalRate: InternalRate; EmployeeRate: EmployeeRate } // Hourly
    | { GrossSalary: number; HourlyRateBasicSalary: number; HourlyRateGrossSalary: number; Overtime: OvertimeSetup; GrossSalaryPackage: GrossSalaryPackage }; // Monthly
}

